<template>
  <Skeleton
    :border-radius="borderRadius"
    :height="height"
    :pt="mergedPt"
    :shape="shape"
    :size="size"
    :width="width"
    v-bind="$attrs"
  />
</template>

<script lang="ts" setup>
import { Skeleton } from 'primevue'
import { computed } from 'vue'

import usePrimeVuePtMerge from '@/composables/use-prime-vue-helpers/usePrimeVuePtMerge'

import { DEFAULT_TWN_SKELETON_PROPS, type TwnSkeletonProps } from './TwnSkeleton.types'

const props = withDefaults(defineProps<TwnSkeletonProps>(), DEFAULT_TWN_SKELETON_PROPS)

const defaultPt = {}

const mergedPt = computed(() => {
  return usePrimeVuePtMerge(defaultPt, props.pt).value
})
</script>
